import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionHeartbeatPayload } from 'api/actions/revision-heartbeat/revision-heartbeat-payload';
import { RevisionHeartbeatPathParameters } from 'api/actions/revision-heartbeat/revision-heartbeat-path-parameters';
import { RevisionHeartbeatResponse } from 'api/actions/revision-heartbeat/revision-heartbeat-response';

type RevisionHeartbeatQueryParameters = Record<string, any>;

/**
 * The path of the RevisionHeartbeat action.
 */
export const revisionHeartbeatActionPath = new SweetPath<keyof RevisionHeartbeatPathParameters>(
  '/api/revision/heartbeat/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionHeartbeat actions.
 */
export default function createRevisionHeartbeatAction(axios: AxiosInstance) {
  return function revisionHeartbeatAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionHeartbeatPathParameters;
    query?: RevisionHeartbeatQueryParameters;
    payload: RevisionHeartbeatPayload;
  }) {
    const path = revisionHeartbeatActionPath.insert(parameters);

    return axios.request<RevisionHeartbeatResponse, RevisionHeartbeatResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
